import { useEffect, useState } from "react";
import {
  AddWeekConfig,
  GetAllWeekConfig,
  UpdateWeekConfig,
} from "../services/RangeDateEvent";
import { useDispatch } from "react-redux";
import { setErrorMessage, setSuccessMessage } from "../slices/messageSlice";
import Filter from "../components/Filter";
import WeekConfigTable from "../components/WeekConfigTable";

const ManageWeekConfig = () => {
  const [weekConfigs, setWeekConfigs] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  const [isUse, setIsUse] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  // Hàm lấy dữ liệu tuần sự kiện từ API
  const getWeekConfigs = async () => {
    setIsLoading(true);
    try {
      const response = await GetAllWeekConfig(selectedDate, isUse);
      if (response.status_code === 200) {
        setWeekConfigs(response.data.data);
      } else {
        dispatch(setErrorMessage(response.message));
      }
    } catch (error) {
      dispatch(setErrorMessage("Có lỗi xảy ra khi tải dữ liệu"));
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getWeekConfigs();
  }, []);

  // Cập nhật trạng thái "Sử dụng"
  const onUpdateWeekConfig = async (id, isCurrentUsed, weekData) => {
    try {
      const response = await UpdateWeekConfig(
        id,
        weekData.startDate,
        weekData.endDate,
        weekData.name,
        weekData.amountDate,
        isCurrentUsed
      );
      if (response.status_code === 200) {
        getWeekConfigs();
        dispatch(setSuccessMessage("Cập nhật thành công"));
      } else {
        dispatch(setErrorMessage(response.message));
      }
    } catch (error) {
      dispatch(setErrorMessage("Có lỗi xảy ra khi cập nhật trạng thái"));
    }
  };

  const onUpdateSwitch = async (id, isCurrentUsed) => {
    try {
      const weekToUpdate = weekConfigs.find((week) => week.id === id);
      const response = await UpdateWeekConfig(
        id,
        weekToUpdate.startDate,
        weekToUpdate.endDate,
        weekToUpdate.name,
        weekToUpdate.amountDate,
        isCurrentUsed
      );
      if (response.status_code === 200) {
        getWeekConfigs();
        dispatch(setSuccessMessage("Cập nhật trạng thái thành công"));
      } else {
        dispatch(setErrorMessage(response.message));
      }
    } catch (error) {
      dispatch(setErrorMessage("Có lỗi xảy ra khi cập nhật trạng thái"));
    }
  };

  // Tải lại dữ liệu khi có thay đổi lọc
  const onApplyFilter = () => {
    getWeekConfigs();
  };

  const handleAddWeekConfig = async (newWeek) => {
    try {
      console.log(newWeek)
      const response = await AddWeekConfig(
        newWeek.startDate,
        newWeek.endDate,
        newWeek.name,
        newWeek.amountDate
      );

      if (response.status_code === 200) {
        getWeekConfigs();
        dispatch(setSuccessMessage("Thêm tuần mới thành công"));
      } else {
        dispatch(setErrorMessage(response.message));
      }
    } catch (error) {
      dispatch(setErrorMessage("Có lỗi xảy ra khi thêm tuần mới"));
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl overflow-hidden">
          <div className="px-6 py-8 sm:px-8">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
                  Quản lý Config Tuần sự kiện
                </h1>
                <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
                  Quản lý và cấu hình các tuần sự kiện cho hệ thống
                </p>
              </div>
              <div className="flex items-center space-x-4">
                <div className="text-sm text-gray-500 dark:text-gray-400">
                  Tổng số tuần: {weekConfigs.length}
                </div>
              </div>
            </div>

            {/* Phần lọc */}
            <Filter
              selectedDate={selectedDate}
              setSelectedDate={setSelectedDate}
              isUse={isUse}
              setIsUse={setIsUse}
              onApplyFilter={onApplyFilter}
            />

            {/* Bảng danh sách tuần sự kiện */}
            <div className="mt-6">
              {isLoading ? (
                <div className="flex justify-center items-center py-12">
                  <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600"></div>
                </div>
              ) : (
                <WeekConfigTable
                  weekConfigs={weekConfigs}
                  onUpdateWeekConfig={onUpdateWeekConfig}
                  handleUpdateSwitch={onUpdateSwitch}
                  onAddWeekConfig={handleAddWeekConfig}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageWeekConfig;
